// This file centralizes ALL data for the HireDjango page
export const hireDjangoPageDataArabic = {
  "helmet": {
    "title": "وظّف مطوري Django | خدمات تطوير Django",
    "description": "وظّف مطوري جانغو المهرة للحصول على حلول ويب آمنة وعالية الأداء. خدمات تطوير جانغو الخبيرة لجميع أحجام الأعمال."
  },
  "hirePageBanner": {
    "diffBannerBackgroundImage": "url(/images/hire-page-images/hire-django.avif)",
    "image": "",
    "mainHeading": "وظّف مطوري جانغو",
    "content": "هل تبحث عن أفضل مطوري جانغو؟ في Bitsclan، نقدم خبراء مفروزين مسبقًا لبناء تطبيقات ويب آمنة وقابلة للتطوير وعالية الأداء مصممة خصيصًا للشركات الناشئة والمؤسسات.",
    "btnText": "استشر مطوري جانغو لدينا",
    "bannerList": [
      { "list": "خيارات توظيف مرنة" },
      { "list": "وظائف بدوام كامل" },
      { "list": "فرق عالمية" }
    ]
  },
  "hirePageExperties": {
    btnText: "حدد موعدًا لإجراء مكالمة اليوم",
    "heading": "خبرة مطوري جانغو لدينا",
    "discription": "في Bitsclan، يتفوق مطورو جانغو لدينا في بناء تطبيقات ويب آمنة وقابلة للتطوير وغنية بالميزات. من خلال الاستفادة من قوة Python و Django، نقدم تطويرًا سلسًا يتوافق تمامًا مع أهداف عملك.",
    "servicesData": [
      {
        "title": "استشارات جانغو",
        "description": "هل تحتاج إلى إرشادات خبراء لمشروع جانغو الخاص بك؟ يوفر مطورو جانغو المهرة لدينا تخطيطًا استراتيجيًا ومشورة فنية لمساعدتك على تحسين مشروعك وتحقيق أقصى قدر من الكفاءة.",
        "icon": "/images/hire-page-icons/hire-django-icon1.svg"
      },
      {
        "title": "تطوير ويب جانغو",
        "description": "نحن متخصصون في بناء تطبيقات ويب قوية وغنية بالميزات وقابلة للتطوير باستخدام جانغو. سواء كنت تطلق مشروعًا جديدًا أو تقوم بترقية مشروع موجود، يضمن مطورونا أداءً سلسًا وتجربة مستخدم استثنائية.",
        "icon": "/images/hire-page-icons/hire-django-icon2.svg"
      },
      {
        "title": "تطوير واجهة برمجة تطبيقات جانغو (API)",
        "description": "يبني خبراء جانغو لدينا واجهات برمجة تطبيقات (APIs) آمنة وفعالة تمكن من التواصل السلس بين التطبيقات والخدمات. من واجهات برمجة التطبيقات الداخلية إلى عمليات التكامل مع الجهات الخارجية، نحن نوفر لك كل ما تحتاجه.",
        "icon": "/images/hire-page-icons/hire-django-icon3.svg"
      },
      {
        "title": "تطوير أنظمة إدارة المحتوى (CMS) وبوابات جانغو",
        "description": "هل تبحث عن نظام إدارة محتوى (CMS) قوي أو بوابة ويب؟ يبني مطورو جانغو لدينا حلولًا مرنة وسهلة الإدارة وقابلة للتطوير وتتوافق تمامًا مع متطلبات عملك.",
        "icon": "/images/hire-page-icons/hire-django-icon4.svg"
      },
      {
        "title": "الترحيل إلى جانغو",
        "description": "هل تخطط لترحيل نظامك الحالي إلى جانغو؟ يتعامل خبراؤنا مع الانتقال بسلاسة، مما يضمن الحد الأدنى من التوقف عن العمل وأقصى قدر من الأداء.",
        "icon": "/images/hire-page-icons/hire-django-icon5.svg"
      },
      {
        "title": "التكامل مع الحلول الموجودة",
        "description": "يتخصص مطورو جانغو لدينا في دمج تطبيقات جانغو مع الأنظمة الأساسية الأخرى وواجهات برمجة التطبيقات (APIs) وخدمات الجهات الخارجية، مما يضمن وظائف سلسة وأداءً محسّنًا.",
        "icon": "/images/hire-page-icons/hire-django-icon6.svg"
      },
      {
        "title": "حلول التجارة الإلكترونية جانغو",
        "description": "نحن نبني منصات تجارة إلكترونية عالية الأداء باستخدام جانغو، ونقدم بوابات دفع آمنة، وتجربة مستخدم سلسة، وبنية قابلة للتطوير لدفع مشاركة العملاء.",
        "icon": "/images/hire-page-icons/hire-django-icon7.svg"
      },
      {
        "title": "دعم وصيانة جانغو",
        "description": "تأكد من أن تطبيق جانغو الخاص بك يعمل بسلاسة من خلال خدمات الدعم والصيانة المستمرة لدينا. نتعامل مع التحديثات المنتظمة، وتحسين الأداء، وإصلاح الأخطاء للحفاظ على استقرار وأمان منصتك.",
        "icon": "/images/hire-page-icons/hire-django-icon8.svg"
      }
    ]
  },
  "developmentPerformance": {
    btnText: "توظيف مطور اليوم",
    "heading": "لماذا توظّف مطوري جانغو ",
    "greenHeading": "من Bitsclan؟",
    "subHeading": "في Bitsclan، نجمع بين جانغو وأحدث تقنيات الواجهة الأمامية والخلفية لبناء تطبيقات آمنة وقابلة للتطوير وعالية الأداء مصممة خصيصًا لاحتياجات عملك.",
    "solutions": [
      {
        "icon": "/images/hire-page-icons/chose-ror-section1.svg",
        "title": "الوصول إلى المواهب المفروزة",
        "description": "قابل مطوري جانغو المهرة الذين تم فحصهم بعناية لخبرتهم الفنية وطلاقتهم في اللغة الإنجليزية. يمكنك التأكد من أنك تعمل مع محترفين من الطراز الأول."
      },
      {
        "icon": "/images/hire-page-icons/chose-ror-section2.svg",
        "title": "شاهد المطابقات في ثوانٍ",
        "description": "لا مزيد من البحث اللانهائي عن السير الذاتية. اعثر على مطوري جانغو المثاليين للتوظيف بسرعة وسهولة من خلال منصتنا ببضع نقرات فقط."
      },
      {
        "icon": "/images/hire-page-icons/chose-ror-section3.svg",
        "title": "وفّر مع التوظيف العالمي",
        "description": "استفد من مجموعة مواهب تضم 450,000 متخصص عبر 190 دولة. من خلال خيارات التوظيف العالمية لدينا، يمكنك توفير ما يصل إلى 58% مقارنة بأساليب التوظيف التقليدية، دون المساومة على الجودة.",
        "noBorder": true
      },
      {
        "icon": "/images/hire-page-icons/chose-ror-section4.svg",
        "title": "احصل على دعم بشري حقيقي",
        "description": "اشعر بالثقة عندما توظّف مطوري جانغو بدعم فريق التوظيف الخبير لدينا. نحن هنا لإرشادك في كل خطوة على الطريق، مما يضمن لك العثور على الموهبة المناسبة لمشروعك."
      }
    ]
  },
  "hireCombinationSection": {
    "combinations": [
      {
        "title": "جانغو + بوستغريس كيو إل + رياكت",
        "description": "جانغو كإطار عمل خلفي قوي، بوستغريس كيو إل لإدارة قواعد البيانات المنظمة، ورياكت لبناء تطبيقات الواجهة الأمامية الديناميكية تضمن حل ويب قابل للتطوير وعالي الأداء.",
        "icons": ["django.svg", "postgres.svg", "react.svg"]
      },
      {
        "title": "جانغو + GraphQL",
        "description": "تمكن GraphQL استعلامات البيانات الفعالة، ويوفر جانغو واجهة خلفية آمنة وقابلة للتطوير، ويضمن بوستغريس كيو إل تخزين بيانات موثوقًا، مما يجعله خيارًا ممتازًا للتطبيقات الحديثة.",
        "icons": ["django.svg", "graphql.svg", "postgres.svg"]
      },
      {
        "title": "جانغو + Redux Toolkit",
        "description": "يؤدي دمج جانغو مع Redux Toolkit إلى تعزيز إدارة الحالة في تطبيقات الواجهة الأمامية مع الحفاظ على واجهة خلفية قوية مع جانغو وبوستغريس كيو إل.",
        "icons": ["django.svg", "redux.svg", "postgres.svg"]
      },
      {
        "title": "جانغو + Next.js",
        "description": "يمكّن Next.js عرض جانب الخادم (SSR) لتحسين تحسين محركات البحث والأداء، مقترنًا بجانغو كواجهة خلفية لإنشاء تطبيقات سريعة وقابلة للتطوير وآمنة.",
        "icons": ["django.svg", "next-js.svg", "postgres.svg"]
      }
    ],
    "heading": "أفضل تركيبات تقنية جانغو لتطوير قوي",
    "description": "استفد من إطار عمل جانغو القوي مع أفضل تركيبات التقنيات لبناء تطبيقات آمنة وقابلة للتطوير وعالية الأداء. وظّف مطوري جانغو خبراء لضمان تطوير سلس ونتائج استثنائية."
  },
  "hirePageSteps": {
    btnText: "دعنا نجد المطور المثالي لك",
    "heading": "وظّف مطوري جانغو في 4 خطوات سهلة",
    "subHeading": "أصبح توظيف أفضل مطوري جانغو الآن سريعًا وخاليًا من المتاعب من خلال عمليتنا البسيطة المكونة من 4 خطوات. نضمن لك تجربة سلسة والموهبة المناسبة لمشروعك.",
    "steps": [
      {
        "title": "اختر نموذج التعاقد الخاص بك",
        "description": "اختر نموذج التعاقد الذي يناسب مشروعك - سواء كان بدوام كامل أو جزئي أو بالساعة. نقدم خيارات مرنة لتناسب احتياجاتك.",
        "icon": "/images/hire-page-setps-icons/icon-1.svg"
      },
      {
        "title": "فحص واختيار مطوري جانغو",
        "description": "تصفح أفضل مطوري جانغو المتاحين للتوظيف واختر أفضل المرشحين لمشروعك. يمكنك مراجعة ملفاتهم الشخصية واختيار المناسبين للمضي قدمًا.",
        "icon": "/images/hire-page-setps-icons/icon-2.svg"
      },
      {
        "title": "إجراء مقابلة فردية",
        "description": "قابل المطورين الذين تم اختيارهم لتقييم مهاراتهم وخبراتهم. اطرح أسئلة نظرية وعملية للتأكد من أنهم مناسبون تمامًا لفريقك.",
        "icon": "/images/hire-page-setps-icons/icon-3.svg"
      },
      {
        "title": "إعداد مطوري جانغو",
        "description": "بمجرد اتخاذ قرارك، سينضم مطور جانغو النهائي إلى فريقك في غضون 24-48 ساعة بعد التأكيد، وسيكون جاهزًا لبدء العمل في مشروعك.",
        "icon": "/images/hire-page-setps-icons/icon-4.svg"
      }
    ]
  },
  "coverTheStack": {
    "whereStart": "إطار العمل",
    "mainHeading": "وظّف مطوري جانغو خبراء لتطبيقات ويب قابلة للتطوير وآمنة",
    "subHeading": "في Bitsclan، ندعم رحلة تطوير الويب الخاصة بك باستخدام حزمة تقنية جانغو قوية تضمن الكفاءة والأمان وقابلية التوسع. يستفيد مطورو جانغو ذوو الخبرة لدينا من التقنيات الحديثة لبناء تطبيقات ويب مخصصة وعالية الأداء مصممة خصيصًا لاحتياجات عملك.",
    "tabs": [
      "إطار العمل",
      "المكتبات",
      "الأدوات والمرافق",
      "قاعدة البيانات",
      "أدوات إدارة المشاريع"
    ],
    "tabItems": [
      { "tab": "إطار العمل", "icon": "/images/django-tech.svg", "name": "Django" },
      { "tab": "إطار العمل", "icon": "/images/tech-stack-icons/Pyramid.svg", "name": "Pyramid" },
      { "tab": "إطار العمل", "icon": "/images/tech-stack-icons/Flask.svg", "name": "Flask" },
      { "tab": "إطار العمل", "icon": "/images/tech-stack-icons/bottle.svg", "name": "Bottle" },
      { "tab": "المكتبات", "icon": "/images/tech-stack-icons/fabric.svg", "name": "Fabric" },
      { "tab": "المكتبات", "icon": "/images/tech-stack-icons/request.svg", "name": "Requests" },
      { "tab": "المكتبات", "icon": "/images/tech-stack-icons/pillow.svg", "name": "Pillow/PIL" },
      { "tab": "المكتبات", "icon": "/images/database6.png", "name": "wxPython" },
      { "tab": "المكتبات", "icon": "/images/tech-stack-icons/scrapy.svg", "name": "Scrapy" },
      { "tab": "الأدوات والمرافق", "icon": "/images/tech-stack-icons/numpy.svg", "name": "NumPy" },
      { "tab": "الأدوات والمرافق", "icon": "/images/database1.png", "name": ".Net" },
      { "tab": "الأدوات والمرافق", "icon": "/images/database6.png", "name": "Python" },
      { "tab": "الأدوات والمرافق", "icon": "/images/tech-stack-icons/ruby_on_rails.svg", "name": "Ruby On Rails" },
      { "tab": "الأدوات والمرافق", "icon": "/images/tech-stack-icons/java.svg", "name": "Java" },
      { "tab": "الأدوات والمرافق", "icon": "/images/database8.png", "name": "PHP" },
      { "tab": "الأدوات والمرافق", "icon": "/images/django-tech.svg", "name": "Django" },
      { "tab": "الأدوات والمرافق", "icon": "/images/tech-stack-icons/golang.svg", "name": "Go" },
      { "tab": "الأدوات والمرافق", "icon": "/images/tech-stack-icons/c-sharp.svg", "name": "C#" },
      { "tab": "الأدوات والمرافق", "icon": "/images/tech-stack-icons/kotlin.svg", "name": "Kotlin" },
      { "tab": "الأدوات والمرافق", "icon": "/images/tech-stack-icons/scala.svg", "name": "Scala" },
      { "tab": "الأدوات والمرافق", "icon": "/images/tech-stack-icons/rust.svg", "name": "Rust" },
      { "tab": "قاعدة البيانات", "icon": "/images/db5.png", "name": "MySQL" },
      { "tab": "قاعدة البيانات", "icon": "/images/tech-stack-icons/oracals.svg", "name": "Oracle" },
      { "tab": "قاعدة البيانات", "icon": "/images/db7.png", "name": "SQLite" },
      { "tab": "قاعدة البيانات", "icon": "/images/db6.png", "name": "MS SQL" },
      { "tab": "قاعدة البيانات", "icon": "/images/db3.png", "name": "MongoDB" },
      { "tab": "قاعدة البيانات", "icon": "/images/tech-stack-icons/redis.svg", "name": "Redis" },
      { "tab": "قاعدة البيانات", "icon": "/images/tech-stack-icons/postgres.svg", "name": "Postgres" },
      { "tab": "أدوات إدارة المشاريع", "icon": "/images/tech-stack-icons/jira.svg", "name": "Jira" },
      { "tab": "أدوات إدارة المشاريع", "icon": "/images/tech-stack-icons/trello.svg", "name": "Trello" },
      { "tab": "أدوات إدارة المشاريع", "icon": "/images/tech-stack-icons/slack-icon.png", "name": "Slack" },
      { "tab": "أدوات إدارة المشاريع", "icon": "/images/tech-stack-icons/zoom-icon.svg", "name": "Zoom" },
      { "tab": "أدوات إدارة المشاريع", "icon": "/images/tech-stack-icons/google-meet.webp", "name": "Google Meet" }
    ]
  },
  "hireExpertFacts": {
    btnText: "حجز موعد",
    "heading": "حقائق سريعة حول ",
    "greenHeading": "فريق جانغو لدينا",
    "facts": [
      {
        "text": "أكثر من <strong>40</strong> مطور جانغو خبير مستعدون لإحياء مشروعك."
      },
      {
        "text": "يتمتع مطورونا بمتوسط خبرة يزيد عن <strong>6 سنوات</strong> في خدمات تطوير جانغو."
      },
      { "text": "الكفاءة في تطوير الويب الآمن باستخدام جانغو، مما يضمن أمان تطبيقك" },
      {
        "text": "خبرة واسعة في تطوير الواجهة الأمامية والخلفية."
      },
      { "text": "ماهرون في بناء تطبيقات ويب قابلة للتطوير وغنية بالميزات باستخدام جانغو." },
      { "text": "ملمون جيدًا بدمج جانغو مع مختلف المنصات والخدمات." }
    ],
    "diffBannerBackgroundImage": "url(/images/hire-page-images/hire-django-arabic.avif)"
  },
  "hirePageAppIdea": {
    heading: "لست متأكدًا من فكرة تطبيقك؟ احصل على النموذج الأولي خلال 6 إلى 8 أسابيع!",
    "content": "هل لديك فكرة ولكنك غير متأكد من كيفية المضي قدمًا؟ يمكن لخبراء جانغو لدينا مساعدتك في بناء نموذج عملي في غضون 6-8 أسابيع فقط! تحقق من رؤيتك، واختبر مشاركة المستخدم، وقم بإرساء أساس متين للنجاح."
  },
  "hirePageEngagementModels": {
    btnText: "ابدأ الآن",
    "headingContent": [
      { "text": "نماذج التعاقد" },
      { "text": "المرنة لدينا" }
    ],
    "discription": "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل، أو جزئي، أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس وأقصى قدر من الكفاءة طوال مشروعك.",
    "hiringDetails": [
      {
        "text": "توظيف بالساعة",
        "hours": "24 - 48",
        "timeUnit": "ساعة",
        "icon": "time.svg",
        "bgColor": "#FDFDFF",
        "durationLabel": "المدة",
        "duration": "8 ساعات/يوم",
        "minimumDaysLabel": "الحد الأدنى للأيام",
        "minimumDays": "30 يومًا",
        "billingLabel": "الفواتير",
        "billing": "شهريًا",
        "startWorkPhrase": "ابدأ العمل في غضون "
      },
      {
        "text": "توظيف بدوام كامل",
        "hours": "48",
        "timeUnit": "ساعة",
        "icon": "full-time.svg",
        "bgColor": "#FFFEFA",
        "durationLabel": "المدة",
        "duration": "8 ساعات/يوم",
        "minimumDaysLabel": "الحد الأدنى للأيام",
        "minimumDays": "30 يومًا",
        "billingLabel": "الفواتير",
        "billing": "شهريًا",
        "startWorkPhrase": "ابدأ في غضون "
      },
      {
        "text": "توظيف بدوام جزئي",
        "hours": "24 - 48",
        "timeUnit": "ساعة",
        "icon": "part-time.svg",
        "bgColor": "#FDFFFA",
        "durationLabel": "المدة",
        "duration": "8 ساعات/يوم",
        "minimumDaysLabel": "الحد الأدنى للأيام",
        "minimumDays": "30 يومًا",
        "billingLabel": "الفواتير",
        "billing": "شهريًا",
        "startWorkPhrase": "انطلق في غضون "
      }
    ]
  },
  "secondFaq": {
    "specificClass": "mobile-dev-page",
    "faqs": [
      {
        "id": "collapseOne",
        "question": "لماذا يجب أن أوظف مطوري جانغو من فريقكم؟",
        "answer": "يتمتع مطورو جانغو لدينا بفهم عميق لبناء تطوير ويب آمن باستخدام جانغو، ونحن متخصصون في إنشاء تطبيقات ويب قابلة للتطوير وعالية الأداء مصممة خصيصًا لاحتياجات عملك. بفضل سنوات الخبرة، فإن مطورينا ماهرون في تطوير الواجهة الأمامية والخلفية، مما يضمن أن مشروعك في أيد أمينة."
      },
      {
        "id": "collapseTwo",
        "question": "كيف أبدأ إذا أردت توظيف مطوري جانغو؟",
        "answer": "ببساطة تواصل معنا بتفاصيل مشروعك، وسنقدم لك خطة واضحة. من هناك، يمكنك اختيار مطور جانغو المناسب للتوظيف بناءً على احتياجاتك. نساعدك في توجيهك خلال عملية التوظيف بأكملها، مما يضمن تجربة سلسة."
      },
      {
        "id": "collapseThree",
        "question": "ما هي أنواع خدمات تطوير جانغو التي تقدمونها؟",
        "answer": "نحن نقدم مجموعة من خدمات تطوير جانغو، بما في ذلك تطوير الويب المتكامل، وتطوير واجهات برمجة التطبيقات (API)، وأنظمة إدارة المحتوى (CMS)، وحلول التجارة الإلكترونية، والترحيل إلى جانغو. بغض النظر عما يتطلبه مشروعك، يمكننا بناؤه باستخدام إطار عمل جانغو القوي."
      },
      {
        "id": "fourth",
        "question": "كيف تضمنون الجودة في مطوري جانغو لديكم؟",
        "answer": "يخضع جميع مطوري جانغو لدينا للتوظيف لعملية فحص صارمة لضمان أنهم ماهرون وذوو خبرة وجاهزون لتقديم نتائج عالية الجودة. نركز أيضًا على التدريب المستمر للحفاظ على تحديث مطورينا بأحدث الاتجاهات وأفضل الممارسات في تطوير جانغو."
      },
      {
        "id": "fifth",
        "question": "ما مدى سرعة توقعي لرؤية النتائج بعد توظيف مطور جانغو؟",
        "answer": "بناءً على نطاق المشروع، نضمن أن تبدأ في رؤية النتائج في غضون أيام قليلة من إعداد مطور جانغو الخاص بك. عمليتنا فعالة، ويعمل فريقنا بسرعة لتقديم النتائج مع الحفاظ على معايير عالية الجودة."
      },
      {
        "id": "sixth",
        "question": "ما هي نماذج التعاقد لديكم لتوظيف مطوري جانغو؟",
        "answer": "نحن نقدم ثلاثة نماذج تعاقد مرنة: دوام كامل، دوام جزئي، وبالساعة. سواء كنت تبحث عن مساعدة طويلة الأمد أو دعم قصير الأمد، يمكننا تكييف نموذج التعاقد ليناسب احتياجاتك، مما يضمن تطويرًا فعالًا وفعالًا من حيث التكلفة."
      }
    ],
    "mainHeading": "الأسئلة الشائعة",
    "subHeading": "استكشف خدمات تطوير جانغو لدينا للحصول على حلول ويب مخصصة وإنشاء واجهات برمجة التطبيقات وإدارة النشر!"
  },
  "trendsInsights": {
    "specificClass": "mobile-dev-page",
    "category": "all"
  },
  "contactSection": {},
  "footer": {}
}